__turbopack_context__.v({
  "centeredCell": "columnsTabContent-module-scss-module__6J6UgG__centeredCell",
  "checkbox": "columnsTabContent-module-scss-module__6J6UgG__checkbox",
  "columnsTable": "columnsTabContent-module-scss-module__6J6UgG__columnsTable",
  "deselectedRow": "columnsTabContent-module-scss-module__6J6UgG__deselectedRow",
  "dragCell": "columnsTabContent-module-scss-module__6J6UgG__dragCell",
  "hideDeselectedHeader": "columnsTabContent-module-scss-module__6J6UgG__hideDeselectedHeader",
  "hideDeselectedLabel": "columnsTabContent-module-scss-module__6J6UgG__hideDeselectedLabel",
  "hideDeselectedToggle": "columnsTabContent-module-scss-module__6J6UgG__hideDeselectedToggle",
  "label": "columnsTabContent-module-scss-module__6J6UgG__label",
  "lockedRow": "columnsTabContent-module-scss-module__6J6UgG__lockedRow",
  "noResults": "columnsTabContent-module-scss-module__6J6UgG__noResults",
  "pinnedRow": "columnsTabContent-module-scss-module__6J6UgG__pinnedRow",
  "scopeValue": "columnsTabContent-module-scss-module__6J6UgG__scopeValue",
  "selectAllHeaderInner": "columnsTabContent-module-scss-module__6J6UgG__selectAllHeaderInner",
});
